export default "/videos/b01e0d31b291472fdcb42b432dc4cf87.mp4";